module.exports = __webpack_public_path__ + "static/RST-PIO-CAN-Flansch-b88fabfb3bbbdb49c0d58c774dd82f1d.jpg";